import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionService {
  private storage: Record<string, unknown> = {};

  setItem(key: string, value: unknown): void {
    this.storage[key] = value;
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    if (item) {
      try {
        return JSON.parse(item) as T;
      } catch {
        return null;
      }
    }
    return null;
  }

  removeItem(key: string): void {
    delete this.storage[key];
    localStorage.removeItem(key);
  }

  getUserInfo(): unknown {
    return this.getItem('user');
  }

  clear(): void {
    this.storage = {};
    localStorage.clear();
  }
}